import React from 'react'
import { DetailDiv } from './style'

function Details() {
    return (
        <DetailDiv>
            <div className="inner-container">

                <div className = "row">
                    <div className = "col-md-3 col-sd-12 reg">
                        <div className="roundhouse">
                            <div className="round">
                            
                            </div>
                        </div>
                        <h5>Get Prescription</h5>
                        <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. 
                            </p>
                    </div>



                    <div className = "col-md-3 col-sd-12 reg">
                        <div className="roundhouse">
                            <div className="round">
                            
                            </div>
                        </div>
                    <h5>Search for a Doctor</h5>
                        <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. 
                            </p>
                    </div>



                    <div className = "col-md-3 col-sd-12 reg">
                        <div className="roundhouse">
                            <div className="round">
                            
                            </div>
                            
                        </div>
                    <h5>Talk to a Pharmacy</h5>
                        <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. 
                            </p>
                    </div>

                    <div className = "col-md-3 col-sd-12 reg">
                        <div className="roundhouse">
                            <div className="round">
                            
                            </div>
                        </div>

                    <h5>Get your medics Delivered</h5>
                        <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. 
                            </p>
                    </div>
                </div>
            </div>
        </DetailDiv>
    )
}

export default Details
